export default import.meta.ROLLDOWN_FILE_URL_EI2HA1QOBUuBufLZEawAnA